module.exports = __webpack_public_path__ + "files/ef702846784ede26314b2fefcc43f513.png";